import { Component, AfterViewInit } from '@angular/core';
import { StringWidget } from '../string.widget';

@Component( {
  selector: 'sp-durationdays-widget',
  templateUrl: './durationdays.widget.html',
} )
export class DurationDaysWidget extends StringWidget implements AfterViewInit {

  private _value = '';

  get value() {
    return this._value;
  }

  ngAfterViewInit() {
    this.formProperty.valueChanges.subscribe(( newValue ) => {
      if ( this.control.value !== newValue ) {
        this._value = newValue ? this.calc( newValue ) : '';
      }
    } );
  }

  calc( totalDays: number ): string {
    if ( totalDays <= 0 ) return '';

    const weeks = Math.floor( totalDays / 7 );
    const days = totalDays - ( weeks * 7 );

    const weeksString = weeks > 0 ? `${weeks} ${this._n( weeks, 'week', 'weeks' )}` : '';
    const daysString = days > 0 ? `${days} ${this._n( days, 'day', 'days' )}` : '';

    return [ weeksString, daysString ].filter( String ).join( ' + ' );
  }

  _n( n: number, singular: string, plural: string ) {
    return Math.abs( n ) === 1 ? singular : plural;
  }

}



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/custom/durationdays.widget.ts